export default __webpack_public_path__ + "static/cash-f79553ce17695d64fecb46fd0335d1aa.mp3";